module.exports = __webpack_public_path__ + "img/76350.7806971d.svg";